document.addEventListener("DOMContentLoaded", initialiseDiscountField );
document.addEventListener("refreshPromoField", initialiseDiscountField );

document.addEventListener('on:line-item:change', (event) => {
  initialiseDiscountField();
});

document.addEventListener('on:cart:add', (event) => {
  initialiseDiscountField();
});

function initialiseDiscountField(apply, button) { 
  console.log("INIT DISCOUNT FIELD");
  let clearBtn = document.querySelector("#clear-discount-btn");
  let applyBtn = document.querySelector("#apply-discount-btn");
  let discountCodeError = document.querySelector("#discount-code-error");
  let discountCodeWrapper = document.querySelector("#applied-discount-code .applied-discount-code-wrapper");
  let discountCodeSuccessMessage = document.querySelector(".discount-code-success");
  let discountCodeErrorContainer = document.querySelector('.discount-code-error-container');
  let discountCodeSavings = document.querySelector('.discount-code-savings');
  let discountCodeIndicator = document.querySelector(".discount-code-indicator");
  let discountCodeValue = document.querySelector("#applied-discount-code .applied-discount-code-value");
  let discountCodeInput = document.querySelector("#discount-code-input");
  let automaticDiscountCode = document.querySelector('#auto-discount-code');
  // let totalCartSelector = document.querySelector(".cart__summary-subtotal [data-cart-total]"); // Total Cart Selector to update the total amount. 
  let authorization_token;
  
  let checkoutContainer = document.createElement('div');
  document.body.appendChild(checkoutContainer);

  if(automaticDiscountCode && !apply) {
    let title = automaticDiscountCode.getAttribute('data-title');
    if(title) {
      applyDiscount(title);
    }
  } else if (localStorage.discountCode && !apply) {
    applyDiscount( JSON.parse(localStorage.discountCode).code);
  }

  // if(applyBtn) {
  //   applyBtn.addEventListener("click", function(e){
  //     e.preventDefault()
  //     applyDiscount(discountCodeInput.value);
  //   });
  // }

  if(clearBtn)
  clearBtn.addEventListener("click", function(e){
    e.preventDefault()
    clearDiscount();
  });

  function clearDiscount() {
    discountCodeValue.innerHTML = "";
    discountCodeError.innerHTML = "";
    clearLocalStorage();
    fetch("/checkout?discount=%20");
  }

  function clearLocalStorage() {
    // let totalCartSelector = document.querySelector(".cart-subtotal__amount span");
    if(discountCodeWrapper) discountCodeWrapper.style.display = "none";
    // if(totalCartSelector && localStorage.discountCode) {
    //   totalCartSelector.innerHTML = JSON.parse(localStorage.discountCode).totalCart;
    // }
    localStorage.removeItem("discountCode");
  }

  function applyDiscount(code) {
    if(applyBtn) {
      applyBtn.innerHTML = (applyBtn.dataset.labelApply || "Appliquer") + " <div class='loader'></div>";
      applyBtn.style.pointerEvents = "none";
    }
    fetch(`${window.Shopify.routes.root}cart/update.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        discount: code
      })
    })
    .then(function(response) { return response.json() })
    .then(function(cart) {
      console.log("DATA", cart);
      let applicableDiscounts = cart.discount_codes.filter(discount => discount.applicable === true);
      if(cart && applicableDiscounts.length > 0) {
        let currentPromo = cart.discount_codes.find((discount) => {
          return discount.code === code;
        });
        if(!currentPromo) {
          return
        }
        fetch('/cart?view=discount', {})
        .then(function(res){return res.text();})
        .then(function(data) {
          console.log(data);
          let dataObject = JSON.parse(JSON.stringify(data))
          dataObject = JSON.parse(dataObject)
          console.log(dataObject);
          let appliedPromo = dataObject.discounts.find((discount) => {
            return discount.title.toUpperCase() === code.toUpperCase();
          });

          if(discountCodeWrapper) discountCodeWrapper.style.display = "block";
          if(discountCodeError) discountCodeError.innerHTML = "";
          if(discountCodeValue) discountCodeValue.innerHTML = appliedPromo.title + " (" + appliedPromo.amount + ' ' + Shopify.currency.active + ")";
          if(discountCodeIndicator) discountCodeIndicator.innerHTML = appliedPromo.title;
          if(discountCodeSavings) discountCodeSavings.innerHTML = appliedPromo.amount; 
          if(discountCodeErrorContainer) discountCodeErrorContainer.style.display = 'none';
          if(discountCodeSuccessMessage) {
            discountCodeSuccessMessage.style.display = 'block';
            document.querySelector(".cart-promo-toggle").classList.add("hide");
            document.querySelector(".cart-sidebar-discount").classList.add("show");
            let cartFullPriceElement = document.querySelector('.cart__summary__original-price-container');
            if(cartFullPriceElement) cartFullPriceElement.classList.remove('hidden');
          }

          let localStorageValue = {
            'code': code.trim()
          };
          debugger
          localStorage.setItem("discountCode", JSON.stringify(localStorageValue));
          let totalCartSelector = document.querySelector('.cart-subtotal__amount span');
          if(totalCartSelector) totalCartSelector.innerHTML = dataObject.total_price_with_currency;
          let comparePriceCartSelector = document.querySelector('.cart-subtotal__amount s');
          if(comparePriceCartSelector) comparePriceCartSelector.innerHTML = dataObject.total_full_price;
          
        });
      } else {
        if(discountCodeValue) discountCodeValue.innerHTML = "";
        clearLocalStorage();
        fetch('/cart?view=discount', {})
        .then(function(res){return res.text();})
        .then(function(data) {
          console.log(data);
          let dataObject = JSON.parse(JSON.stringify(data))
          dataObject = JSON.parse(dataObject);
          let totalCartSelector = document.querySelector('.cart-subtotal__amount span');
          let comparePriceCartSelector = document.querySelector('.cart-subtotal__amount s');
          if(comparePriceCartSelector) comparePriceCartSelector.innerHTML = "";
          if(totalCartSelector) totalCartSelector.innerHTML = dataObject.total_price_with_currency;

          
        });
        if(discountCodeError) {
          const errorTemplate = (applyBtn && applyBtn.dataset.errorTemplate) || "Le code promo __CODE__ n'a pas pu être appliqué";
          discountCodeError.innerText = errorTemplate.replace("__CODE__", discountCodeInput.value);
          discountCodeErrorContainer.style.display = 'block';
        }
      }
    }).finally(function(params) {
      if(applyBtn){
        applyBtn.innerHTML = applyBtn.dataset.labelApply || "Appliquer";
        applyBtn.style.pointerEvents = "all";
      }
      // document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', {
      //   bubbles: true
      // }));
    });

  }
  if(apply === true) {
    if(button.id === "apply-discount-btn") {
      let discountCodeInputText = button.closest('.discount-code-input-container').querySelector('#discount-code-input').value;
      applyDiscount(discountCodeInputText);
    }
  }
}

function hideMessage(e) {
  e.target.closest('.discount-code__message').style.display = 'none';
}

function togglePromoField() {
  // document.querySelector(".cart-promo-toggle").addEventListener("click", function() {
    document.querySelector(".cart-promo-toggle").classList.add("hide"),
    document.querySelector(".cart-sidebar-discount").classList.toggle("show")
  // });
}

function initialiseObserver() {
  // Select the node that will be observed for mutations
  const targetNode = document.getElementById("auto-discount-code");

  // Options for the observer (which mutations to observe)
  const config = { attributes: true, childList: false, subtree: false };

  // Callback function to execute when mutations are observed
  const callback = (mutationList, observer) => {
    for (const mutation of mutationList) {
      if (mutation.type === "attributes") {
        console.log(`The ${mutation.attributeName} attribute was modified.`);

        if(mutation.attributeName === "data-title") {
          applyDiscount();
        }
      }
    }
  };

  // Create an observer instance linked to the callback function
  const observer = new MutationObserver(callback);

  // Start observing the target node for configured mutations
  observer.observe(targetNode, config);
}